import React, { createContext, useState } from 'react';

export const ProcessoContext = createContext();

export default function ProcessoProvider ({children}){

  const [processo,setProcesso] = useState({});

  return (
    <ProcessoContext.Provider value={{processo,setProcesso}}>
      {children}
    </ProcessoContext.Provider>);
    
}

